import { I18nUtil } from "@utils/i18n";
import Translations from "@translate/components/OnboardingWizard/onboardingWizardCopy";
const I18n = I18nUtil.createScoped(Translations);
/** Onboarding wizard copy — ~...~ markers for i18n-google scan. */

/** Figma 97267:68495 — Value proposition copy */
export const VALUE_PROP_COPY = {
  headlineLine1: I18n.t("I'll read"),
  headlineLine2: I18n.t("your money"),
  headlineAccent: I18n.t("in 90 seconds."),
  steps: [
    {
      title: I18n.t("You answer a few quick questions"),
      body: I18n.t("Age, income, the basics — about a minute."),
    },
    {
      title: I18n.t("I read your money in the background"),
      body: I18n.t("I crunch the numbers while you wait."),
    },
    {
      title: I18n.t("You get your Fitness Score"),
      body: I18n.t("Your starting number — and a goal to lift it."),
    },
  ],
  cta: I18n.t("Let's go"),
} as const;

export const QUIZ_COMMON_COPY = {
  edIntro: I18n.t("I'm Ed — your money person."),
  continue: I18n.t("Continue"),
  greetingTemplate: (name: string) =>
    I18n.t("Good to meet you, %{var0}. Just a little about you first.", {
      var0: name,
    }),
} as const;

export const LOADER_COPY = {
  title: I18n.t("Reading your money"),
  errorTitle: I18n.t("Hmm — I hit a snag."),
  errorHint: I18n.t("Your answers are safe — nothing's lost."),
  retry: I18n.t("Try again"),
  rows: [
    I18n.t("Reading your income & savings"),
    I18n.t("Compounding your investments"),
    I18n.t("Finding people on your path"),
    I18n.t("Pinpointing your $1M year"),
  ],
} as const;

export const PLAN_COPY = {
  goalSectionTitle: I18n.t("Goal for you"),
  planSectionTitle: I18n.t("Your Plan"),
  planSectionSubtitle: I18n.t("5 moves get you there sooner"),
  unlockCta: I18n.t("Unlock my full plan"),
  sampleGoal: I18n.t(
    "Bring single-name concentration into your 15% guardrail, staged over 6 months.",
  ),
} as const;

export const SCORE_INTRO_COPY = {
  titleLine1: I18n.t("Meet your"),
  titleLine2: I18n.t("financial fitness score"),
  subtitle: I18n.t("One number for how your money's really doing."),
  cta: I18n.t("Get my score"),
  axisControl: I18n.t("Control"),
  axisSafety: I18n.t("Safety"),
  axisGrowth: I18n.t("Growth"),
  legend: [
    {
      title: I18n.t("Control"),
      body: I18n.t("Your monthly cash flow"),
      dotClass: "bg-content_brand_primary",
    },
    {
      title: I18n.t("Safety"),
      body: I18n.t("Your cushion if a shock hits"),
      dotClass: "bg-content_brand_tertiary",
    },
    {
      title: I18n.t("Growth"),
      body: I18n.t("Your money building"),
      dotClass: "bg-content_brand_quaternary",
    },
  ],
} as const;

export const FITNESS_SCORE_RESULT_COPY = {
  radarTitle: I18n.t("Your Financial fitness score"),
  cardTitle: I18n.t("What's in your score"),
  cta: I18n.t("See where you're headed"),
  dimensions: {
    control: I18n.t("Control"),
    safety: I18n.t("Safety"),
    growth: I18n.t("Growth"),
  },
} as const;
